
import { Vue } from "vue-class-component";
import moment, { lang } from "moment";
import { set, get, keys } from "idb-keyval";
import { Guid } from "guid-typescript";
import { Match } from "../models/Models";
import axios from 'axios';
import router from '../router';

export default class Matches extends Vue {
  public matches: Array<Match> = [];
  public matchesLoaded = false;

  async created() {
    const matchKeys = await keys();

    const matches: Array<Match> = [];

    for (const key of matchKeys) {
      matches.push(await get(key));
    }

    this.matches = matches.sort((a, b) => b.created.localeCompare(a.created));
    this.matchesLoaded = true;
  }

  async newMatch() {
    router.push({ name: "MatchNew" });
  }

  playMatch(match: Match) {
    router.push({ name: "PlayMatch", params: { id: match.id } });
  }

  editMatch(match: Match) {
    router.push({ name: "MatchDetails", params: { id: match.id } });
  }

  goToMatch(match: Match) {
    const hasPlayersOnField = match.players.filter(p => p.isOnField).length > 0;

    if (hasPlayersOnField || match.totalSecondsPlayed > 0 || match.isRunning || match.hasStarted) {
      this.playMatch(match);
    } else {      
      this.editMatch(match);
    }
  }

  setLanguage(language: string) {    
    localStorage.setItem('locale', language);

    this.$i18n.locale = language;
  }
}
